import {H1, H3} from './ui/Header';
import protectedRoute from './protectedRoute';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {API, graphqlOperation} from 'aws-amplify';
import FadeSpinner from './ui/FadeSpinner';
import {getCustomer, listCustomers} from '../graphql/queries';
import {Card} from './ui/Card';
import parseDateTime from '../parseDateTime';
import Accordion, {AccordionItem} from './ui/Accordion';

function Orders() {
  const user = useSelector(state => state.user.currentUser)
  const [transactions, setTransactions] = useState(null)
  const [pending, setPending] = useState(true)

  useEffect(() => {
    // Fetch customer data based on logged in user ID
    const fetchCustomer = async() => {
      const response = await API.graphql(graphqlOperation(`query getCustomer {
        customerByUserID(userID: "${user.id}") {
          items {
            createdAt
            firstname
            id
            lastname
            middlename
            username
            userID
            updatedAt
            phone
            number
            transactions(sortDirection: DESC) {
              items {
                id
                createdAt
                customerID
                total
                subtotal
                shipping
                tax
                updatedAt
                products {
                  items {
                    product {
                      cost
                      description
                      image
                      name
                      price
                    }
                  }
                }
              }
            }
          }
        }
      }
      `))
      console.log(response)
      return response.data.customerByUserID.items[0].transactions.items

    }

    if(user) {
      fetchCustomer()
        .then((response) => {
          console.log(response)
          setTransactions(response)
        })
    }
  }, [user])


  if(!transactions) {
    return <FadeSpinner/>
  }

  return (
    <>
      <H1>Orders</H1>
      { transactions && transactions.map((item, index) =>
        <Card key={item.id}>
          <H3>Order date: {parseDateTime(item.createdAt)}</H3>
          { item.products.items.map(item =>
            <Accordion>
              <AccordionItem title={item.product.name}>
                { Object.entries(item.product).map(([key, value]) =>
                  <div key={key + index}>
                    {key}: {value}
                  </div>
                )}
              </AccordionItem>
            </Accordion>
          )}
        </Card>
      )}
    </>
  )
}

export default protectedRoute(Orders)